import Quill from 'quill'

let Block = Quill.import('formats/link')

class File extends Block {
    static create (value) {
        let node = super.create(value)
        node.setAttribute('controls', 'controls')
        node.setAttribute('style', 'padding-right: 20px;')
        return node
    }
}

File.blotName = 'file'
File.className = 'ql-file'
File.tagName = 'A'

export default File


// WEBPACK FOOTER //
// ./src/components/public/editor/fileload.js